module.exports = ".btn-default, .btn-default:focus {\n  border-color: #d9d9d9; }\n\n/deep/ .modal-wrapper {\n  padding: 25px 25px 0; }\n\n.widget:hover {\n  border-color: #48b0f7;\n  cursor: pointer; }\n\n.widget:hover .btn {\n    border-color: #48b0f7;\n    color: #48b0f7; }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/dashboards/modals/add-widget-modal/add-widget.modal.scss
// module id = ./libs/chassis-core/src/app/dashboards/modals/add-widget-modal/add-widget.modal.scss
// module chunks = main